//#region src/modules/unwrapDefault.ts
function unwrapDefault(value) {
	return value !== null && typeof value === "object" && "default" in value ? value.default : value;
}
//#endregion
export { unwrapDefault };

//# sourceMappingURL=unwrapDefault.js.map